import React, { forwardRef } from 'react';
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';

const EditTaskField = ({ onChange, value, label, disabled, rows, id, size = 'small' }, ref) => {
  return (
    <Grid size={12}>
      <TextField
        id={id}
        label={label}
        size={size}
        value={value}
        variant="outlined"
        disabled={disabled}
        onChange={onChange}
        rows={rows}
        multiline={!!rows}
        fullWidth
      />
    </Grid>
  );
};
export default forwardRef(EditTaskField);
//Original code:
/*import React, {forwardRef } from 'react';
import TextField from '~/TextField/TextField.component';
import Grid from '@mui/material/Grid2';

const EditTaskField = ({ onChange, value, label, disabled, rows, id }, ref) => {

	return (
		<Grid size={12}>
			<TextField
				id={id}
				label={label}
				value={value}
				variant='outlined'
				disabled={disabled}
				onChange={onChange}
				rows={rows}
				multiline={rows ? true : false}
				fullWidth
			/>
		</Grid>
	);
};
export default forwardRef(EditTaskField);
*/
